import { render } from "./CuotasList.vue?vue&type=template&id=b0c2600c"
import script from "./CuotasList.vue?vue&type=script&lang=js"
export * from "./CuotasList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__